import React from "react";
import { Page } from "../components/layout";
import { Accent } from "../components/typography";

const AboutPage = () => (
  <Page>
    <title>LastTalon</title>
    <h1>
      About
      <br />
      <Accent>— coming soon!</Accent>
    </h1>
    <p>This page is currently under construction.</p>
  </Page>
);

export default AboutPage;
